// extracted by mini-css-extract-plugin
module.exports = {"container":"_3ag8vHul-l4Fwr_mySTZmX","event-text":"_1NwjAnTAP2otlVgAYWLu8h","dashboard":"TEM2nPdq_zUq3YP5b-0c-"};